import AuthAutoSignInRedirect from '@components/Auth/AutoSignIn/Redirect/Redirect'

// eslint-disable-next-line react/display-name
export default () => <AuthAutoSignInRedirect />
